export const BILLING_FOR_SEDATION_ANALGESIA_ONLY_REQUIRED_DETAIL = 'billingForSedationAnalgesiaOnly';
export const BILLING_BY_ACT_FOR_SEDATION_ANALGESIA_ONLY_MADE_BY_ANOTHER_DOCTOR_REQUIRED_DETAIL =
  'billingByActForSedationAnalgesiaOnly';

export const PG_28_PDT_OR_SURGERY_MADE_BY_ANOTHER_DOCTOR = 'pg28PdtOrSurgeryMadeByAnotherDoctor';
export const PG_28_PDT_OR_SURGERY_NOT_BILLABLE = 'pg28PdtOrSurgeryNotBillable';

export const RULE_28_ACT_CODES = ['70000', '70002', '70005', '70006', '70010', '70012', '70015', '70016'];
